import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectSelectedGeoentityIdentityCard,
  selectSelectedGeoentityIdentityCardTransportInfo,
  selectSelectedGeoentity,
  selectGeoentityError
} from '../../store/geoentity/geoentity.selectors'
import s from './GeoentityCardHeader.less'
import SVGIcon from '../svg/SVGIcon'
import HeaderDetailMainContent from '../detail/HeaderDetailMainContent'
import GeoentityCardTransportInfo from './GeoentityCardTransportInfo'
import SubHeaderWithETAAndGoToItinerary from '../genericComponents/SubHeaderWithETAAndGoToItinerary'
import SubHeaderDetailContent from '../detail/SubHeaderDetailContent'
import GeoentityCardHeaderPlaceholder from '../../domain/geoentity/GeoentityCardHeaderPlaceholder'
import T from '../i18n/T'

export const GeoentityCardHeader = () => {
  const identityCard = useSelector(selectSelectedGeoentityIdentityCard) || {}
  const transportInfo = useSelector(selectSelectedGeoentityIdentityCardTransportInfo)
  const geoentity = useSelector(selectSelectedGeoentity)
  const error = useSelector(selectGeoentityError)

  if (error)
    return (
      <HeaderDetailMainContent>
        <T id={error} />
      </HeaderDetailMainContent>
    )

  if (!geoentity)
    return (
      <HeaderDetailMainContent>
        <GeoentityCardHeaderPlaceholder />
      </HeaderDetailMainContent>
    )

  return (
    <>
      <HeaderDetailMainContent className={s.headerDetailMainContent}>
        <div className={s.identityCard}>
          <h1 className={s.title}>{identityCard.name}</h1>
          {identityCard.type && !transportInfo && (
            <h2 className={s.type}>
              {identityCard.icon && <SVGIcon className={s.icon} icon={identityCard.icon} />}
              {identityCard.type} {identityCard.rating}
            </h2>
          )}
          <div className={s.addressSection}>
            {identityCard.address && <h2 className={s.address}>{identityCard.address}</h2>}
          </div>
          {transportInfo && <GeoentityCardTransportInfo transportInfo={transportInfo} />}
        </div>
      </HeaderDetailMainContent>
      <SubHeaderDetailContent>
        <SubHeaderWithETAAndGoToItinerary />
      </SubHeaderDetailContent>
    </>
  )
}
export default GeoentityCardHeader
